import React,{useState,useEffect} from 'react'
import { useSelector,connect } from 'react-redux'
import FacturationAccueil from 'pages/Facturation/FacturationAccueil'
import FacturationDetails from 'pages/Facturation/FacturationDetails'
import FacturationPaiement from 'pages/Facturation/FacturationPaiement'
import AddFacture from './AddFacture'
function FacturationHome(props) {
  const [fonctionShow,setFonctionShow] =useState('HOME')
  const handleCliqueFonction =(show,md,cdata)=>{
      if(show === 'UP' ){
        setMode('UP')
      }else{
        setMode(md)
      }
      setData(cdata)
      setFonctionShow(show)
  }
  const [data,setData] =useState(null)
  const [mode,setMode] =useState('ADD')
 const currentmode = useSelector((state)=>state.UI.mode)
 useEffect(()=>{
  if(currentmode==='UP'){
    setFonctionShow('ADD')
  }
 },[currentmode])
  return (
    <div>
    {(fonctionShow==='HOME')&&<FacturationAccueil  handleCliqueFonction={handleCliqueFonction} />}
    {(fonctionShow==='ADD')&&<AddFacture  handleCliqueFonction={handleCliqueFonction} />}
    {(fonctionShow==='LIST')&&<FacturationDetails mode={mode} history={props.history} handleCliqueFonction={FacturationDetails} />}
    {(fonctionShow==='PAI')&&<FacturationPaiement   handleCliqueFonction={handleCliqueFonction} />}
</div>
  )
}

export default FacturationHome